const routes = require('next-routes');

// @see https://github.com/fridays/next-routes
// Additional dynamic routes.
module.exports = routes()
// Single recipe path pattern.
// .add('_recipe', '/recipes/:recipe');
  .add('blog')
  .add('sitemap', '/sitemap.xml')
  .add('nodeRedirect', '/node/:node')
  .add('blog-category', '/blog/:term', 'blog')
  .add('article', '/blog/:term/:node')
  .add('contact')
  .add('vacancies')
  .add('presentations')
  .add('services')
  .add('about')
  .add('portfolio')
  .add('portfolio_project', '/portfolio/:path')
  .add('landing-page', '/lp/:path')
  .add('service-item', '/:term/:node')
  .add('service-type', '/:term')
  .add('service-item-fallback', '/services/:term/:node', 'service-item')
  .add('service-type-fallback', '/services/:term', 'service-type');
